import logo from '@/assets/logo.png'
import ProfileDropdown from '@/components/common/ProfileDropdown'
import { OrganizationDropdown } from '@/components/organization/OrganizationDropdown'
import { cn } from '@/lib/utils'
import { Link, useLocation } from '@tanstack/react-router'

interface NavLinkProps {
  to: string
  children: React.ReactNode
}

function NavLink({ to, children }: NavLinkProps) {
  const location = useLocation()
  return (
    <Link
      to={to}
      className={cn(
        'px-3 py-2 text-xs font-medium text-muted-foreground rounded-md hover:text-primary transition-colors sm:text-sm',
        location.pathname === to && 'text-primary font-semibold',
      )}
    >
      {children}
    </Link>
  )
}

export function Header() {
  return (
    <header className="w-full border-b shadow-sm">
      <div className="flex justify-between items-center px-4 mx-auto max-w-7xl sm:px-6 lg:px-8 min-h-16">
        <div className="flex items-center">
          <span className="flex-shrink-0 text-base font-bold text-gray-900 sm:text-xl">
            <img src={logo} alt="logo" className="w-8 h-8" />
          </span>
          <nav className="flex ml-6 sm:space-x-8">
            <NavLink to="/api-keys">API Keys</NavLink>
            <NavLink to="/webhooks">Webhooks</NavLink>
            <NavLink to="/members">Members</NavLink>
          </nav>
        </div>
        <div className="flex gap-3 items-center">
          <OrganizationDropdown />
          <ProfileDropdown />
        </div>
      </div>
    </header>
  )
}
